import * as React from "react";

import { observer } from "mobx-react-lite";

import { AppDialog } from "components/AppDialog";

import { useStores } from "hooks/useStores";

export const Modals: React.FC = observer(() => {
  const { dialogStore } = useStores();

  return (
    <>
      {dialogStore.visible ? (
        <AppDialog
          data={{
            title: dialogStore.title,
            buttons: dialogStore.buttons,
            description: dialogStore.description,
            icon: dialogStore.icon,
          }}
          onClose={dialogStore.closeModal}
        />
      ) : null}
    </>
  );
});
